import { updateAndStoreDraftedSheets } from '../../../redux/sagas/root/rootHelpers';
import {
  RawCommandsHistoryWithoutChanges,
  SheetManagementSet,
} from '../../../types/sheet/draft';
import { executeSheetsCommand } from './executeSheetsCommand';

type CommandType = 'group' | 'sheet' | 'both';

export async function executeRawSheetsCommands(
  rawCommands: RawCommandsHistoryWithoutChanges[],
  set: SheetManagementSet,
  commandType: CommandType = 'both'
) {
  // const set
  // const set: SheetManagementSet = yield generateSheetsDataSet();

  for (const sheetsCommands of rawCommands) {
    try {
      if (sheetsCommands.creationCommands) {
        for (const command of sheetsCommands.creationCommands) {
          await executeSheetsCommand(set, command);
        }
      }

      if (commandType === 'both' || commandType === 'group')
        if (sheetsCommands.groupCommands) {
          for (const groupId in sheetsCommands.groupCommands) {
            const groupCommands = sheetsCommands.groupCommands[groupId];
            for (const command of groupCommands) {
              await executeSheetsCommand(set, command);
            }
          }
        }

      if (commandType === 'both' || commandType === 'sheet')
        if (sheetsCommands.sheetCommands) {
          for (const sheetId in sheetsCommands.sheetCommands) {
            const sheetCommands = sheetsCommands.sheetCommands[sheetId];
            for (const command of sheetCommands) {
              await executeSheetsCommand(set, command);
            }
          }
        }

      if (sheetsCommands.deletionCommands) {
        for (let command of sheetsCommands.deletionCommands) {
          await executeSheetsCommand(set, command);
        }
      }
    } catch (err) {
      console.log(err)
      console.log('Error while patching raw Commands');
    }
  }

  if (commandType === 'sheet') updateAndStoreDraftedSheets(set);

  return set;

  //   TODO:
  //   Get Groups from set if entity is group OR
  //   Get Sheet from set (temporary + drafted) OR (drafted + updated)
  //   Sync Set to server
}
